import type {StateCreator} from 'zustand'
import type {FilesRoutePayload} from '../../page-data/payloads/files'
import type {PullRequestState} from '../../types'

export interface PullRequestSlice {
  pullRequest: {
    state: PullRequestState
    basePath: string
  }
  pullRequestActions: {
    updatePullRequestState: (pullRequestState: PullRequestState) => void
  }
}
export interface PullRequestSliceOpts {
  pullRequest: FilesRoutePayload['pullRequest']
}

export const createPullRequestSlice =
  ({
    pullRequest,
  }: PullRequestSliceOpts): StateCreator<PullRequestSlice, [['zustand/devtools', never]], [], PullRequestSlice> =>
  _set => {
    return {
      pullRequest: {state: pullRequest.state, basePath: pullRequest.pathName},
      pullRequestActions: {
        updatePullRequestState: newPullRequestState => {
          _set(
            {
              pullRequest: {state: newPullRequestState, basePath: pullRequest.pathName},
            },
            undefined,
            'pullRequest#updatePullRequestState',
          )
        },
      },
    }
  }
